import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-images',
  templateUrl: './card-images.component.html',
  styleUrls: ['./card-images.component.scss']
})
export class CardImagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
